import { getBookingsList } from '../APICalling/APICalling';

const formatDateToDDMMYYYY = (date) =>
    date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '-');

// Active booking = any status except cancelled or no-show (completed counts as active)
export const checkActiveBookings = async ({ therapistId, outletId, date }) => {
    if (!therapistId || !(date instanceof Date) || isNaN(date.getTime())) return false;

    try {
        const dateStr = formatDateToDDMMYYYY(date);
        const response = await getBookingsList({
            outlet: outletId,
            daterange: `${dateStr} / ${dateStr}`,
            therapist: therapistId,
            pagination: 0,
        });
        const bookings = response?.data?.data?.list?.bookings || [];

        return bookings
            .filter((booking) => {
                const status = booking.status?.toLowerCase() || '';
                return !status.includes('no-show') && !status.includes('cancelled');
            })
            .some((booking) => {
                if (!booking.booking_item || typeof booking.booking_item !== 'object') return false;
                return Object.values(booking.booking_item)
                    .flat()
                    .some((item) => Number(item.therapist_id) === Number(therapistId));
            });
    } catch (error) {
        console.error('Error checking bookings:', error);
        return false;
    }
};
